<section class="container">
  <div class="app-container">
    <header class="app-header">
      <div class="d-flex align-items-center">
        <button
          class="btn-back"
          (click)="navigateToBackPage()"
          aria-label="Go back"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <span class="back-text">Back</span>
        </button>
        <h1>E-Content - Semesters</h1>
      </div>
      <div class="header-divider"></div>
    </header>

    <main class="content-container">
      <nav class="semester-nav">
        <ul class="semester-list">
          <li
            *ngFor="let semester of semesters"
            (click)="selectSemester(semester.semister_id)"
            [class.selected]="semester.semister_id === selectedSemester"
            class="semester-item"
          >
            <span class="semester-number"
              >Semester {{ semester.Semester_Number }}</span
            >
            <mat-icon
              class="chevron-icon"
              *ngIf="semester.semister_id === selectedSemester"
            >
              chevron_right
            </mat-icon>
          </li>
        </ul>
      </nav>

      <section class="subject-content">
        <div
          *ngIf="selectedSemester; else noSelection"
          class="subject-container"
        >
          <h2 class="section-title">Subjects</h2>
          <ul class="subject-list">
            <li
              *ngFor="let subject of subjectsList; let i = index"
              class="subject-item"
              (click)="viewESubjectData(subjectsId[i])"
            >
              <div>
                <mat-icon class="subject-icon" color="primary"
                  >menu_book</mat-icon
                >
                <div>
                  <div>
                    <div class="subject-name">{{ subject }}</div>
                    <div class="subject-code">
                      {{ subjectsCode[i] }}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <ng-template #noSelection>
          <div class="empty-state">
            <mat-icon class="empty-icon">select_all</mat-icon>
            <h3>No Semester Selected</h3>
            <p>Please select a semester from the list to view its subjects</p>
          </div>
        </ng-template>
      </section>
    </main>
  </div>
</section>
